const calcRem = (size: number) => `${size / 16}rem`;

const fontSizes = {
    ss: '12px',
    s: '14px',
    m: '16px',
    l: '18px',
    xl: '24px',
    xxl: '32px',
};

const color = {
    blue: '#039BE5',
    grey: '#8E8E8E',
    red: '#E34B1B',
    black: '#222',
    sky: '#F0F7FB',
};

const border = {
    primary: '#f5f5f5',
};

const styledTheme = {
    fontSizes,
    color,
    border,
};

export default styledTheme;
